import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {ICountyModel} from '../../models/ICountyModel';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountiesService {

  constructor(private http: HttpClient) {
  }

  retrieveCounties(year: number, stateId: string): Observable<Array<ICountyModel>> {
    return this.http.get<Array<ICountyModel>>(`${environment.api_url}/public/counties/${year}/${stateId}`);
  }
}
